<template>
  <!-- event="[]" disables router-link's own click-to-navigate: without it, its
       internal click handler and @click.native below both fire router.push on
       the same click, racing each other and corrupting selected_tags on
       deselect (K2-3019). :to is kept only for the real, crawlable href. -->
  <router-link
    :to="localizedRoute(tagPath)"
    :event="[]"
    @click.native.prevent="changeTag"
    :class="{ active: isActive }"
    class="inline-flex middle-xs tag-wrap relative mx5 my5 pointer"
    :id="`tag-${tag.code}`"
  >
    <span>{{ tag.title }}</span>
    <span class="icon-wrapper">
      <img
        v-if="tag.icon"
        :src="icon"
        :alt="tag.title"
        :width="24"
        :height="24"
        loading="eager"
        fetchpriority="high"
      >
    </span>
    <span v-if="isActive" class="material-icons close">highlight_off</span>
  </router-link>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import config from 'config'
import { localizedRoute } from '@vue-storefront/core/lib/multistore'

export default {
  props: {
    tag: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      isTagActive: 'partner_tags/isTagActive',
      currentLocation: 'locations/getActiveLocation',
      activeCategory: 'partner_categories/getActivePartnersCategory'
    }),
    isActive () {
      return this.isTagActive(this.tag)
    },
    icon () {
      return `${config.images.baseUrl}${this.tag.icon}?width=16&height=16&image-type=image`
    },
    // Real href for crawlability (K2-2985's tags were only ever reachable via
    // click-driven router.push, invisible to any crawler that doesn't execute JS
    // and unlinked internally even for ones that do) - matches whatever
    // partner_tags/changeAppliedTags would push for this click: the category-only
    // path when deselecting an already-active tag, this tag's path otherwise.
    // Note: this is a snapshot from the *last render*, stale until Vue re-renders
    // after the click - irrelevant for the real href/crawlers, but see the
    // template's `:event="[]"` for why it must never drive an actual navigation.
    tagPath () {
      if (!this.currentLocation || !this.activeCategory) {
        return ''
      }
      let path = `/${this.currentLocation.code}/${this.activeCategory.code}`
      if (!this.isActive) {
        path += `/${this.tag.code}`
      }
      return path
    }
  },
  methods: {
    localizedRoute,
    ...mapActions({
      toggleTag: 'partner_tags/toggleTag'
    }),
    async changeTag () {
      await this.toggleTag(this.tag)
      this.$emit('changeTag')
    }
  }
}
</script>
<style lang="scss" scoped>
  .tags{
    white-space: nowrap;
    overflow: scroll;
    &.current{
      .tag-wrap{
        display: none;
        &.active{
          display: inline-flex;
        }
      }
    }
  }
  .tag-wrap{
    height: 35px;
    border-radius: 35px;
    border:  1px solid #ebebeb;
    background-color: #ffffff;
    padding: 0 20px;
    font-size: 14px;
    font-family: "TTNorms Medium", sans-serif;
    &.active{
      background-color: #11bb2e;
      color: #fff;
      fill: #fff;
    }

    .icon-wrapper {
      min-width: 32px;
    }

    img{
      margin-left: 10px;
    }
    .material-icons.close{
      font-size: 21px;
      position: absolute;
      right: 0;
      top: -5px;
      color: #000;
      border-radius: 50%;
      background-color: #fff;
    }
  }
  .activewrap{
    .tag-wrap{
      display: none;
    }
    .active{
      display: inline-flex;
    }
  }
</style>
